module.exports = __webpack_public_path__ + "media/paliwa/pb_95@2x-15b2c0d9.png";